import { AxiosResponse } from 'axios';
import api from './api';

export interface Token {
    id: number;
    description: string;
}

function path(endPath: string = ''): string {
    return `/tk${endPath}`;
}

export class TokenService {
    static async getTokens(nodeId: number): Promise<AxiosResponse> {
        return api.get(path(`/${nodeId}`));
    }

    static async createToken(nodeId: number): Promise<AxiosResponse> {
        return api.put(path(), { node_id: nodeId });
    }

    static async removeToken(tokenId: number): Promise<AxiosResponse> {
        return api.delete(path(`/${tokenId}`));
    }
}
